import React from 'react';
import { EventStats } from 'types';
import { LineChartGradients } from 'utils/helpers/lineChart';
import moment from 'moment';
import _ from 'lodash';

interface AttendanceChartElementProps {
  stats: EventStats[];
  days: string[];
  idx: number;
}

const AttendanceChartElement: React.FC<AttendanceChartElementProps> = ({
  stats,
  days,
  idx,
}) => {
  const getEventsPlaceholders = () => {
    const maxEventsLength = 12;
    return (
      <div className="chart__bar__placeholders">
        {[...Array(maxEventsLength)].map(() => (
          <div className="chart__bar__eventElement" />
        ))}
      </div>
    );
  };

  return (
    <div className="table__chart attendance">
      <div className="chart__day">
        {!_.isEmpty(days) && moment(days[idx], 'DD-MM-YYY').format('ddd')}
      </div>
      <div className="chart__bar">
        {getEventsPlaceholders()}
        {stats.map((s) => {
          return (
            <div
              key={s.id}
              className="chart__bar__eventElement"
              style={{
                backgroundImage: s.attended
                  ? LineChartGradients.attendance.left
                  : LineChartGradients.attendance.right,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AttendanceChartElement;
